import { useDocument, useImageAsDocument, useMessageHtmlText } from '.';
import { useMessageImages } from './useMessageImages';
import { EMessageContentType } from '../../../types/messageContentType';
import { TMessage, TOutcomingStatus } from '../../../types/messages';

interface IUseMessageContentTypeParams {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
}

export const useMessageContentType = ({ message, messageId }: IUseMessageContentTypeParams): EMessageContentType => {
  const { offers, files, message: text } = message;

  const { document, documentDraft } = useDocument(messageId, files?.documents?.[0]);

  const { imageAsDocument, imageAsDocumentDraft } = useImageAsDocument(messageId, files?.imagesAsDocuments?.[0]);

  const { imageBlobFiles, imageFiles } = useMessageImages({ message, messageId });

  const htmlText = useMessageHtmlText(message);

  const hasDocument = Boolean(document || documentDraft);

  const hasImageAsDocument = Boolean(imageAsDocument || imageAsDocumentDraft);

  const hasImage = Boolean(imageBlobFiles.length || imageFiles?.length);

  const hasOffer = Boolean(offers?.length);

  const hasText = Boolean(htmlText || text);

  switch (true) {
    case hasDocument:
      return EMessageContentType.Document;

    case hasImageAsDocument:
      return EMessageContentType.ImageAsDocument;

    case hasImage && hasText:
      return EMessageContentType.ImageWithText;

    case hasImage:
      return EMessageContentType.Image;

    case hasOffer:
      return EMessageContentType.Offer;

    case hasText:
    default:
      return EMessageContentType.Text;
  }
};
